import React, { useEffect, useState } from "react";
import {
  Installation,
  Organization,
  Video,
  VideoCataloguesDto,
} from "../common/ObjectTypes";
import { toast } from "react-toastify";
import InstallationsList from "./InstallationsList";
import { MoonLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import { searchInstallations } from "../../api/installations/installationApi";
import { getVideoCatalogues } from "../../api/videoCatalogues.tsx/videoCataloguesApi";
import { getVideos } from "../../api/videos/videosApi";
import { getOrganizations } from "../../api/organizations/organizationsApi";

const ManageInstallationsPage = () => {
  const [installations, setInstallations] = useState<Installation[]>([]);
  const [videoCatalogues, setVideoCatalogues] = useState<VideoCataloguesDto[]>(
    []
  );
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const [videos, setVideos] = useState<Video[]>([]);
  const [pageLoaded, setPageLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reloadPage, setReloadPage] = useState(true);
  // const [query, setQuery] = useState<string>("");
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [recordStart, setRecordStart] = useState(0);
  const [recordEnd, setRecordEnd] = useState(0);
  const pageSize = 25;
  const [searchQuery, setSearchQuery] = useState({
    name: "",
    pageNumber: 1,
    pageSize,
    // selectVideoCataloguesPage ? pageSize : 25,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const loadInstallations = async () => {
      setLoading(true);
      try {
        const temp = await searchInstallations(searchQuery);
        setInstallations(temp.results);
        loadVideoCatalogues();
        loadVideos();
        loadOrgs();
        setPageCount(Math.ceil(temp.totalCount / pageSize));
        setTotalCount(temp.totalCount);
        const start = (searchQuery.pageNumber - 1) * searchQuery.pageSize + 1;
        const end = Math.min(start + temp.results.length - 1, temp.totalCount);

        setRecordStart(start);
        setRecordEnd(end);
        setPageLoaded(true);
        setReloadPage(false);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    const loadVideoCatalogues = async () => {
      try {
        const temp = await getVideoCatalogues();
        setVideoCatalogues(temp);
      } catch (err) {
        console.log(err);
      }
    };

    const loadVideos = async () => {
      try {
        const temp = await getVideos(1, 1000);
        setVideos(temp.results);
      } catch (err) {
        console.log(err);
      }
    };

    const loadOrgs = async () => {
      try {
        const temp = await getOrganizations();
        setOrganizations(temp);
      } catch (err) {
        console.log(err);
      }
    };

    loadInstallations();
  }, [pageLoaded, reloadPage]);

  const handleOnClickAdd = () => {
    navigate("/installation/add");
  };

  const handlePageClick = (selectedItem: { selected: number }) => {
    setSearchQuery((prevQuery) => ({
      ...prevQuery,
      pageNumber: selectedItem.selected + 1,
    }));
    setReloadPage(true);
  };

  const handleSelectInstallation = (id: any) => {
    navigate(`/installation/${id}/edit`);
  };

  const handleSearch = async (e: any) => {
    try {
      setSearchQuery((prevQuery) => ({
        ...prevQuery,
        name: searchQuery.name || "",
        pageNumber: 1,
      }));
      setReloadPage(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleClearSearch = () => {
    try {
      setSearchQuery({
        name: "",
        pageNumber: 1,
        pageSize,
      });
      setReloadPage(true);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery((prevQuery: any) => ({
      ...prevQuery,
      name: event.target.value,
    }));
  };

  const handleDelete = async () => {
    try {
      toast.success("Installation was deleted.", {
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
        autoClose: 2500,
      });
      setPageLoaded(false);
    } catch (error) {
      console.log(error);
    }
  };

  return !pageLoaded ? (
    <div className="flex justify-center items-center">
      <MoonLoader color="#9EB45B" />
    </div>
  ) : (
    <InstallationsList
      installations={installations}
      videoCatalogues={videoCatalogues}
      videos={videos}
      organizations={organizations}
      onSelectInstallation={handleSelectInstallation}
      onClickAdd={handleOnClickAdd}
      onDelete={handleDelete}
      onChangeSearch={handleChangeFilter}
      onSearch={handleSearch}
      onClearSearch={handleClearSearch}
      searchQuery={searchQuery}
      pageCount={pageCount}
      pageSize={pageSize}
      totalCount={totalCount}
      handlePageClick={handlePageClick}
      reloadPage={reloadPage}
      recordStart={recordStart}
      recordEnd={recordEnd}
      loading={loading}
    />
  );
};

export default ManageInstallationsPage;
